/* eslint-disable @typescript-eslint/naming-convention */
import type { AppRouteBeforeServerRenderContext } from 'src/shared/routes';

export const guidesToRedirect = [
	'what-is-a-petition',
	'petition-templates-and-samples',
	'how-to-write-a-petition',
	'do-online-petitions-work',
	'how-to-get-on-the-news',
	'community-problems-identify-and-solve-local-issues',
	'how-to-be-a-policy-advocate',
	'digital-advocacy-guide',
	'how-to-organize-a-protest',
	'social-problems-in-america',
	'top-public-policy-issues-guide',
	'how-to-start-an-environmental-petition',
	'how-to-start-a-criminal-justice-petition',
	'how-to-start-a-healthcare-reform-petition',
	'how-to-start-an-animal-rights-petition',
	'how-to-start-an-lgbtq-rights-petition',
];

/** This is a mapping for articles that have new slugs in petition guides. */
export const newSlugMapping: Record<string, string> = {
	'how-to-get-on-the-news': 'media',
};

/**
 * Handles redirecting select guides pages to the new petition guides in corgi.
 */
export const handleGuidesRedirect = ({ redirect, params: { slug } }: AppRouteBeforeServerRenderContext) => {
	if (!guidesToRedirect.includes(slug)) return;

	redirect(`/petition-guides/${newSlugMapping[slug] ?? slug}`, true);
};
